import React, { Component } from 'react';
import Slider from 'react-slick';
import { topCategoryScrollAuto } from '../../../services/script'
import { addToCart, addToWishlist, addToCompare } from "../../../actions/index";
import TopCategory from '../../layouts/common/topCategory';

class TopCategories extends Component {

    render() {

        const { items, title, themeLayoutId } = this.props;
       // const itemsArray = Object.keys(items)
        return (
            <div>
                {/* Fashion */}
                {
                    themeLayoutId === "L01" && 
                    <>
                     {/*Paragraph*/}
                        <div className="title1  section-t-space">
                        {/* <h4>special offer</h4> */}
                        <h2 className="title-inner1" style={{'textTransform': 'none',marginBottom:0}}>{title}</h2>
                    </div>  
                    {/*Paragraph End*/}
                    <section className="section-b-space p-t-0" style={{paddingBottom:15}}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <Slider {...topCategoryScrollAuto} className="product-4 product-m home-slider">

                                    {items.length > 0 && items.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <TopCategory product={item} themeLayoutId={themeLayoutId} />
                                            </div>)
                                    })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                    </section>
                    </>
                }
                {/* End Fashion */}

                {/* Furniture */}
                {
                    themeLayoutId === "L02" && 

                    <section className="p-t-0 p-b-0">  
                    <div className="container-fluid">
                        <div className="row section-t-space">
                            <div className="col">
                                <Slider {...topCategoryScrollAuto} className="product-4 product-m no-arrow">

                                    {items.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <TopCategory product={item} themeLayoutId={themeLayoutId} />
                                            </div>)
                                    })
                                    }
                                </Slider>
                            </div>
                        </div>
                    </div>
                </section>
                }
                {/* end Furniture */}
            </div>
        )
    }
}

export default (TopCategories);